const treatmentCategory = [
{id: 1, label: "Teeth Cleaning (Prophylaxis)", value: "Teeth-cleaning"},
{id: 2, label: "Fillings", value: "fillings"},
{id: 3, label: "Root Canal Treatment", value: "root-canal-treatment"},
{id: 4, label: "Dental Crowns", value: "Dental-Crowns"},
{id: 5, label: "Bridges and Implants", value: "Bridges-and-Implants"},
{id: 6, label: "Braces and Orthodontics", value: "Braces-and-Orthodontics"},
{id: 7, label: "Teeth Whitening", value: "Teeth-Whitening"},
{id: 8, label: "Dental Extractions", value: "Dental-Extractions"},
{id: 9, label: "Dentures", value: "Dentures"},
{id: 10, label: "Veneers", value: "Veneers"},
{id: 11, label: "Periodontal Treatment", value: "Periodontal-Treatment"},
{id: 12, label: "Oral Surgery", value: "Oral-Surgery"},
{id: 13, label: "Other", value: "Other"}
]
export default treatmentCategory